var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Dashboard" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.detail"),
                    active: !_vm.developmentMode
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CustomerCriteriaId,
                              label: "Label",
                              source: _vm.lookup.CUSTOMER_CRITERIA
                                ? _vm.lookup.CUSTOMER_CRITERIA.filter(function(
                                    c
                                  ) {
                                    return (
                                      c.Code == "MK" ||
                                      c.Code === "ML" ||
                                      c.Code === "TM"
                                    )
                                  })
                                : []
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customerCriteria,
                              callback: function($$v) {
                                _vm.customerCriteria = $$v
                              },
                              expression: "customerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteCriteriaId",
                            error: _vm.$v.form.RouteCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RouteCriteriaId,
                              "lookup-key": "ROUTE_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "RouteCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.routeCriteria,
                              callback: function($$v) {
                                _vm.routeCriteria = $$v
                              },
                              expression: "routeCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchCriteriaId",
                            error: _vm.$v.form.BranchCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.BranchCriteriaId,
                              "lookup-key": "BRANCH_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BranchCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.BranchCriteria,
                              callback: function($$v) {
                                _vm.BranchCriteria = $$v
                              },
                              expression: "BranchCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BeginDate",
                            error: _vm.$v.form.BeginDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.BeginDate },
                            model: {
                              value: _vm.form.BeginDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BeginDate", $$v)
                              },
                              expression: "form.BeginDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "EndDate",
                            error: _vm.$v.form.EndDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.EndDate },
                            model: {
                              value: _vm.form.EndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "EndDate", $$v)
                              },
                              expression: "form.EndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.CycleInstruction.EmployeesList")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.employeeItems },
                    model: {
                      value: _vm.form.CycleInstructionEmployees,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CycleInstructionEmployees", $$v)
                      },
                      expression: "form.CycleInstructionEmployees"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.BranchCriteria && _vm.BranchCriteria.Code === "SL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.CycleInstruction.CycleInstructionBranches"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.branchItems },
                        model: {
                          value: _vm.branches,
                          callback: function($$v) {
                            _vm.branches = $$v
                          },
                          expression: "branches"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria &&
              _vm.customerCriteria.Code === "ML" &&
              ((_vm.BranchCriteria && _vm.BranchCriteria.Code === "SL") ||
                (_vm.BranchCriteria && _vm.BranchCriteria.Code === "TS"))
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.CycleInstruction.CycleInstructionCustomers"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.customerItems },
                        model: {
                          value: _vm.customers,
                          callback: function($$v) {
                            _vm.customers = $$v
                          },
                          expression: "customers"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.routeCriteria && _vm.routeCriteria.Code === "RL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.CycleInstruction.CycleInstructionRoutes"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.routeItems },
                        model: {
                          value: _vm.routes,
                          callback: function($$v) {
                            _vm.routes = $$v
                          },
                          expression: "routes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.Code
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.CycleInstruction.CycleInstructionTaskItems"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.taskItems,
                          "main-form": _vm.form,
                          "before-add": _vm.beforeValidTasksAdd
                        },
                        model: {
                          value: _vm.form.CycleInstructionTasks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CycleInstructionTasks", $$v)
                          },
                          expression: "form.CycleInstructionTasks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.CycleInstruction.CycleInstructionCriterias"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.criteriaItems },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bdd33fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdd33fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CycleInstruction/update.vue
// module id = null
// module chunks = 